<template>
    <div>
        <v-data-table :loading="loading" :search="search" disable-initial-sort :rows-per-page-items="rowPerPage"
            :headers="headers" :items="repairmen" class="elevation-1 rounded-lg">
            <template #headers="props">
                <tr>
                    <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers"
                        :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td class="text-no-wrap text-center">
                        <v-menu offset-y>
                            <v-btn icon slot="activator">
                                <v-icon small color="#464D69">settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile @click="triggerEditDialog(props.item)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Chỉnh sửa
                                    </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="handleDelete(props.item._id)">
                                    <v-list-tile-action>
                                        <v-icon small class="zmdi zmdi-account"></v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Xóa
                                    </v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>

                    <td class="text-no-wrap text-center">{{ props.item.name }}</td>
                    <td class="text-no-wrap text-center">{{ props.item.daily_hours }} giờ</td>
                    <td class="text-no-wrap text-center">{{ props.item.daily_wage | formatCurrency }}</td>
                </tr>
            </template>
            <template #no-data>
                Chưa có thông tin
            </template>
        </v-data-table>
    </div>
</template>

<script>
import api from 'Api';
import { formatCurrency, buildParamQuery } from 'Helpers';

export default {
    name: "TableThoSuaChua",
    props: {
        reload_table: Number,
        search: String,
        loader: Boolean,
        type: String
    },
    data() {
        return {
            repairmen: [],
            loading: false,
            headers: [
                { text: "Thao tác", align: "center", sortable: false },
                { text: "Tên Thợ Sửa", align: "center", sortable: true, value: "name" },
                { text: "Số Giờ Làm Việc/Ngày", align: "center", sortable: true, value: "daily_hours" },
                { text: "Lương Ngày", align: "center", sortable: true, value: "daily_wage" },
            ],
            rowPerPage: [10, 20, 50, { "text": "Tất cả", "value": -1 }],
        };
    },
    watch: {
        reload_table() {
            this.getData();
        },
        loading(nv) {
            this.$emit("update:loader", nv);
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.repairmen = [];
            this.loading = true;
            try {
                const params = {type: this.type};
                const query = buildParamQuery(params)
                const response = await api.getRepairmen(query);
                if (response.status === 200) {
                    this.repairmen = response.data.map(item => {
                        item.daily_hours = Number(item.daily_hours);
                        item.daily_wage = Number(item.daily_wage);
                        return item;
                    });
                } else {
                    swal.fire('Lỗi', response.data.message || 'Không thể tải danh sách thợ sửa chữa', 'error');
                }
            } catch (err) {
                console.error('Lỗi khi tải danh sách thợ sửa chữa:', err);
                swal.fire('Lỗi', err.message || 'Đã xảy ra lỗi khi tải dữ liệu.', 'error');
            } finally {
                this.loading = false;
            }
        },
        triggerEditDialog(repairman) {
            this.$emit('triggerDialog', repairman, 'edit');
        },
        async handleDelete(id) {
            this.loading = true;
            try {
                const response = await api.deleteRepairman(id);
                console.log("🚀 ~ handleDelete ~ response:", response)
                if (response.status === 200) {
                    swal.fire('Đã xóa!', response.data.message, 'success');
                    await this.getData();
                } else {
                    swal.fire('Lỗi', response.data.message || 'Không thể xóa thợ sửa chữa', 'error');
                }
            } catch (err) {
                console.error('Lỗi khi xóa thợ sửa chữa:', err);
                swal.fire('Lỗi', err.message || 'Đã xảy ra lỗi khi xóa dữ liệu.', 'error');
            } finally {
                this.loading = false;
            }

        },
    },
};
</script>

<style scoped>
.v-data-table {
    background-color: #ffffff;
}

.v-data-table th {
    background-color: #f0f4f7;
    font-weight: bold;
    color: #424242 !important;
    text-transform: uppercase;
    font-size: 0.85rem;
}

.v-data-table td {
    font-size: 0.9rem;
    color: #616161;
}

.v-btn.blue {
    background-color: #2196f3 !important;
}

.v-btn.red {
    background-color: #f44336 !important;
}
</style>